var map = {
  "./InstagramSlider.ts": [
    "6143",
    "676"
  ],
  "./TabbedContent.ts": [
    "3081",
    "466"
  ],
  "./definition": [
    "4389"
  ],
  "./AbstractSwiper.ts": [
    "6446",
    "545",
    "187"
  ],
  "./CustomSwiper": [
    "8623",
    "545",
    "572"
  ],
  "./DummyClass": [
    "2920",
    "929"
  ],
  "./definition.ts": [
    "4389"
  ],
  "./PageNavigation": [
    "6825",
    "866"
  ],
  "./AnchoredCTA.ts": [
    "2236",
    "989"
  ],
  "./InstagramSlider": [
    "6143",
    "676"
  ],
  "./NumberCounter.js": [
    "6331",
    "545",
    "856"
  ],
  "./AnchoredCTA": [
    "2236",
    "989"
  ],
  "./DummyClass.ts": [
    "2920",
    "929"
  ],
  "./NumberCounter": [
    "6331",
    "545",
    "856"
  ],
  "./CustomSwiper.ts": [
    "8623",
    "545",
    "572"
  ],
  "./TabbedContent": [
    "3081",
    "466"
  ],
  "./PageNavigation.ts": [
    "6825",
    "866"
  ],
  "./AbstractSwiper": [
    "6446",
    "545",
    "187"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
    return __webpack_require__(id);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 5985;
module.exports = __rspack_async_context;
